export interface IEquatable<T> {
    isEquals(right: T): boolean;
    getHash(): number;
}
